import { snakeCase } from 'lodash-es';

/**
 * Formats a string to an 'analytics-friendly' format.
 * @param value Of an analytics payload.
 * @see 'cap 2.6' of 'Tealium IQ: Manuale di implementazione per le sezioni responsive di sisal.it'
 */
export function formatAnalyticsValue(value: string): string {
  return snakeCase(value.toLowerCase());
}
